import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';
import getAllRes from './getAll.json';
import getByIdRes from './getByIdRes.json';
import getMonthlyCommissionByDateRangeAndIdRes from './getMonthlyCommissionByDateRangeAndId.json';
import getPartnerCommissionRes from './getPartnerCommissions.json';

const getAll = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-partners`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllRes>(url, config);
};

const getById = (id: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-partner?partnerId=${id}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getByIdRes>(url, config);
};

const remove = (id: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}delete-partner`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  const data = {
    id,
  };
  return axios.post(url, data, config);
};

export interface AddPartnerData {
    'name': string,
    'address': {
        'streetAddress': string,
        'zipCode': string;
        'state': string;
        'city': string;
    },
    'contactPerson': {
        'firstname': string;
        'lastname': string;
        'position': string;
        'phoneNumber': string
        'email': string
    },
    'commision':number
}

const add = (data: AddPartnerData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-partner`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

export interface UpdatePartnerData {
    'id': number;
    'name': string,
    'address': {
        'streetAddress': string,
        'zipCode': string;
        'state': string;
        'city': string;
    },
    'contactPerson'?: {
        'firstname': string;
        'lastname': string;
        'position': string;
        'phoneNumber': string
        'email': string
    },
    'comission':number
}
const update = (data: UpdatePartnerData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-partner`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

// date format 20190801 or 20190901
const getMonthlyCommissionByDateRangeAndId = (startDate: string, endDate: string, partnerId: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}partner-totalsales-summary-bydate?partnerId=${partnerId}&startDateStr=${startDate}&endDateStr=${endDate}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getMonthlyCommissionByDateRangeAndIdRes>(url, config);
};

const getPartnerCommissions = (partnerId: string) => {
  console.log('Partner Commissions');
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-partner-commissions?partnerId=${partnerId}`;
  console.log(url);
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getPartnerCommissionRes>(url, config);
};

export interface AddPartnerCommissionData {
    'partnerId':number;
    'salesFrom':string;
    'salesTo':string;
    'totalSales':number;
    'totalCount':number;
    'totalCommission':number;
}

const addCommission = (data: AddPartnerCommissionData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-partner-commission`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

export interface CommissionPaymentData {
    'id':number;
    'paymentAmount':number;
    'paymentDate'?:string;
    'paymentType'?:number;
}

const commissionPayment = (data: CommissionPaymentData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}pay-partner-commission`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const partner = {
  getAll,
  remove,
  update,
  add,
  getById,
  getMonthlyCommissionByDateRangeAndId,
  getPartnerCommissions,
  addCommission,
  commissionPayment,
};

export default partner;
